import { jsxs as n, jsx as i } from "react/jsx-runtime";
import { Container as r, Image as e, FirstLine as o, SecondLine as t, LineContainer as d, ThirdLine as a, FourthLine as c } from "./style.js";
const h = () => /* @__PURE__ */ n(r, { children: [
  /* @__PURE__ */ i(e, {}),
  /* @__PURE__ */ n("div", { children: [
    /* @__PURE__ */ i(o, {}),
    /* @__PURE__ */ i(t, {}),
    /* @__PURE__ */ n(d, { children: [
      /* @__PURE__ */ i(a, {}),
      /* @__PURE__ */ i(c, {})
    ] })
  ] })
] });
export {
  h as NotificationBarLoadingItem
};
